
<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="gasStation/findOderListAdmin.action"
                        ref="GasOrderListTable">
            <template slot="search">

              <el-row>
                <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                  <el-form-item>
                    <el-select v-model="queryParams.payStatus"  @change="loadData" clearable placeholder="请选择">
                      <el-option label="待支付" :value="1"></el-option>
                      <el-option label="支付成功" :value="2"></el-option>
                      <el-option label="支付失败" :value="3"></el-option>
                      <el-option label="支付关闭" :value="4"></el-option>
                      <el-option label="转入退款" :value="5"></el-option>
                      <el-option label="取消支付" :value="6"></el-option>
                      <el-option label="支付中" :value="7"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>

                    <el-date-picker

                        @change="onDateTimeChange"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="datetimerange"
                        v-model="queryParams.startEndTime">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-input   placeholder="用户手机/油站名称" v-model="queryParams.keyword"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="loadData" type="primary" >搜索</el-button>

                  </el-form-item>
                  <el-form-item>
                    <el-button @click="exportGasOrder()" type="danger">导出</el-button>
                  </el-form-item>
                </el-form>
              </el-row>
                <row>
                    <el-col>
                        <div style="height: 40px;margin-bottom: -15px;margin-top: 15px">
                            加油总金额：{{moneyData.gasAmount/100}} 元  累计优惠金额：{{moneyData.discountAmount/100}}元  累计服务费：{{moneyData.serviceAmount/100}}元  实付总金额：{{moneyData.paymentAmount/100}} 元
                        </div>
                    </el-col>
                </row>

            </template>
            <template slot="item">
              <el-table-column
                  label="来源渠道"
                  prop="channelName" v-belong-to-admin>
              </el-table-column>
                <el-table-column
                        label="订单号"
                        prop="orderNumber">
                </el-table-column>
                <el-table-column
                        label="用户手机号"
                        prop="phone">
                </el-table-column>
                <el-table-column
                        label="省市区"
                        prop="city">
                </el-table-column>
                <el-table-column
                        label="交易油站"
                        prop="gasStationName">
                </el-table-column>
                <el-table-column
                        label="平台类型"
                        v-if="queryParams.channelId+'' == 'undefined'  ">
                    <template scope="scope">
                        {{ scope.row.externalType| typeFilter }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="油号"
                        prop="">
                  <template scope="scope">
                    {{scope.row.gasolineLabel}}/{{scope.row.gunName}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="加油金额"
                        prop="gasAmount">
                  <template scope="scope">
                    {{scope.row.gasAmount | coverMoneyFilter}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="优惠金额"
                        prop="discountAmount">
                  <template scope="scope">
                    {{scope.row.discountAmount | coverMoneyFilter}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="服务费"
                        prop="serviceAmount">
                  <template scope="scope">
                    {{scope.row.serviceAmount | coverMoneyFilter}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="实际支付"
                        prop="paymentAmount">
                  <template scope="scope">
                    {{scope.row.paymentAmount | coverMoneyFilter}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="支付状态"
                        prop="payStatus">
                  <template scope="scope">
                    {{scope.row.payStatus | payStatusFilter}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="支付时间"
                        prop="payTime">
                  <template scope="scope">
                    {{scope.row.payTime | dateTimeFormat}}
                  </template>
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createDate">
                  <template scope="scope">
                    {{scope.row.createDate | dateTimeFormat}}
                  </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'GasOrderList',
  data: function () {
    return {
      queryParams: { payStatus: 2 },
      moneyData: {
        gasAmount: 0,
        discountAmount: 0,
        serviceAmount: 0,
        paymentAmount: 0
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.queryParams.channelId = userInfo.id
    this.loadData()
  },
  methods: {
    exportGasOrder: function () {
      let userInfo = JSON.parse(localStorage.userInfo)
      let dataStr = '&channelId=' + userInfo.id
      if (!userInfo.id) {
        dataStr = ''
      }
      if (this.queryParams.startTime) {
        dataStr += '&startTime=' + this.queryParams.startTime
      }

      if (this.queryParams.endTime) {
        dataStr += '&endTime=' + this.queryParams.endTime
      }

      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }

      if (this.queryParams.payStatus) {
        dataStr += '&payStatus=' + this.queryParams.payStatus
      }

      window.location.href = Config.baseUrl + '/gasStation/exportGasOrder.action?token=' + userInfo.token + '&loginAccountId=' + (userInfo.id ? userInfo.id : userInfo.employeeId) + '&loginPath=' + userInfo.loginPath + dataStr
    },
    loadData () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.moneyData = dataInfo.datas
          } else {
            _this.moneyData.gasAmount = 0
            _this.moneyData.discountAmount = 0
            _this.moneyData.paymentAmount = 0
            _this.moneyData.serviceAmount = 0
          }
        }
      }
      BasicModel.get(this, 'gasStation/getGasOrderMoneyByAdmin.action', this.queryParams, listener)
      this.$refs.GasOrderListTable.search()
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.loadData()
    }
  },
  filters: {
    payStatusFilter (value) {
      // 支付状态:1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中(用户唤起支付)
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '待支付'
          break
        case 2:
          filterValue = '支付成功'
          break
        case 3:
          filterValue = '支付失败'
          break
        case 4:
          filterValue = '支付关闭'
          break
        case 5:
          filterValue = '转入退款'
          break
        case 6:
          filterValue = '取消支付'
          break
        case 7:
          filterValue = '支付中'
          break
      }
      return filterValue
    },
    typeFilter (value) {
      // 状态:1-待审核2-已通过 3-已驳回
      let filterValue = '省心加油'
      switch (value) {
        case 1:
          filterValue = '省心加油'
          break
        case 2:
          filterValue = '易加油'
          break
        case 3:
          filterValue = '小桔加油'
          break
        case 4:
          filterValue = '团油'
          break
      }
      return filterValue
    },
    coverMoneyFilter (value) {
      //
      let filterValue = value / 100

      return filterValue
    }
  }
}
</script>

<style scoped>
</style>
